import { render } from "./VoluntaryLearn.vue?vue&type=template&id=52826491"
import script from "./VoluntaryLearn.vue?vue&type=script&lang=ts"
export * from "./VoluntaryLearn.vue?vue&type=script&lang=ts"

import "./VoluntaryLearn.vue?vue&type=style&index=0&id=52826491&lang=css"
script.render = render

export default script